import "./skeletonLoader.scss";

/*
 * Reusable shimmering skeleton placeholder. Uses the global .ds-skeleton shimmer.
 *   <SkeletonLoader type="table|cards|stats|list|form" rows={6} cards={3} />
 */
const arr = (n) => Array.from({ length: n });

function SkeletonLoader({ type = "table", rows = 6, cards = 3 }) {
  switch (type) {
    case "cards":
      return (
        <div className="skeleton skeleton-cards">
          {arr(cards).map((_, i) => <div key={i} className="ds-skeleton skeleton-cards__item" />)}
        </div>
      );
    case "stats":
      return (
        <div className="skeleton skeleton-stats">
          {arr(cards).map((_, i) => <div key={i} className="ds-skeleton skeleton-stats__item" />)}
        </div>
      );
    case "form":
      return (
        <div className="skeleton skeleton-form">
          {arr(rows).map((_, i) => <div key={i} className="ds-skeleton skeleton-form__field" />)}
        </div>
      );
    case "list":
      return (
        <div className="skeleton skeleton-list">
          {arr(rows).map((_, i) => <div key={i} className="ds-skeleton skeleton-list__item" />)}
        </div>
      );
    case "table":
    default:
      return (
        <div className="skeleton skeleton-table">
          <div className="ds-skeleton skeleton-table__head" />
          {arr(rows).map((_, i) => <div key={i} className="ds-skeleton skeleton-table__row" />)}
        </div>
      );
  }
}

export default SkeletonLoader;
